export default [
  // {
  //   path: '/diamond/list',
  //   name: 'diamond-list',
  //   component: () => import('@/views/diamond/Diamond.vue'),
  //   meta: {
  //     allowAnonymous: false,
  //     pageTitle: 'Categories List',
  //     breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Category' }, { title: 'Category List', active: true }]
  //   }
  // },
  // {
  //   path: '/diamond/add',
  //   name: 'create-diamond',
  //   component: () => import('@/views/diamond/AddDiamondModal.vue'),
  //   meta: {
  //     allowAnonymous: false,
  //     pageTitle: 'Add Diamond',
  //     breadcrumb: [
  //       { title: 'Dashboard', url: '/dashboard' },
  //       { title: 'Diamonds', url: '/diamond/list' },
  //       { title: 'Add Category', active: true }
  //     ]
  //   }
  // },
]
